<template>
  <v-dialog v-model="dialog" max-width="290">
    <v-card>
      <v-card-title class="text-h5">
        {{title}}
      </v-card-title>

      <v-card-text>
        {{content}}
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="green darken-1" text @click="close">
          No
        </v-btn>

        <v-btn color="green darken-1" text @click="onSubmit">
          Yes
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    content: {
      type: String,
      default: "",
    },
    onSetConfirmedDialog: {
      type: Function,
    },

    confirmedDialog: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    dialog: {
      get() {
        return this.confirmedDialog;
      },
      set(val) {
        this.onSetConfirmedDialog(val);
      },
    },
  },
  methods: {
    onSubmit() {
      this.$emit("confirmed");
    },
    close() {
      this.dialog = false;
    },
  },
};
</script>
